<tag-selector>
    <select ref="multi" class="full-width" multiple style="width: 100%">
        <option each="{item in opts.selectionList}" value="{item}">{item}</option>
    </select>

    <br if="{opts.scopedTags.length}">
    <br if="{opts.scopedTags.length}">
    <br if="{opts.scopedTags.length}">

    <span each="{item in opts.scopedTags}"
          onclick="{_setValue}"
          class="label label-info d-inline-flex"
          style="padding: 10px; margin: 5px; cursor: pointer;"
    >{item}</span>



    <script>

        const tag = this;

        tag.getSelectOpts = () => {
            let selectOpts = {
                placeholder: "tag search",
            };

            if (opts.ajax)
                selectOpts['ajax'] = {
                    url: opts.ajax,
                    delay: 350,
                    processResults: (data) => {
                        return {results :data.tags.map((item) => {return {id: item, text: item}})}
                    }
                };

            return selectOpts;
        };

        tag._setValue = (event) => {
            event.preventUpdate = true;
            tag.addValue(event.item.item);
        };

        tag.getValues = () => {
            let rawValues = [];
            tag.selector.select2('data').forEach((item) => {
                rawValues.push(item.text)
            });
            return rawValues;
        };

        tag.addValue = (value) => {
            tag.selector.val([...tag.getValues(), value]).trigger('change');
            if (opts.onSelect)
                opts.onSelect(tag.getValues())
        };

        tag.on('mount', () => {

            tag.selector = $(tag.refs.multi).val(!(opts.ajax) ? (opts.selectedList || []) : []).select2(
                tag.getSelectOpts()
                // {placeholder: "filter results using tags",}
            );

            tag.selector.on('select2:select', function (e) {
                if (opts.onSelect)
                    opts.onSelect(e)
            });

            tag.selector.on('select2:unselect', function (e) {
                if (opts.onSelect)
                    opts.onSelect(e)
            });
        });

        tag.on('updated', () => {
            tag.selector.val(opts.selectedList).trigger('change');
        });

    </script>
</tag-selector>


// WEBPACK FOOTER //
// avr_eshop/frontend/components/tag-selector/tag-selector.tag.html